const s = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
};
export {
  s as BANNER_COLOR
};
